import { registerSystem } from "@core/registry";
import { splittermondUi } from "../systems/splittermond";

registerSystem(splittermondUi);
